/* global window */
import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/index.scss';
import ImmersiveLightbox from './javascripts/immersiveLightbox';


if (process.env.NODE_ENV === 'production') {
  const url = new URL(document.currentScript.src);
  const widgetLink = url.href.substring(0, url.href.lastIndexOf('/') + 1);
  // eslint-disable-next-line no-unused-vars, no-undef
  __webpack_public_path__ = widgetLink;
}

let reactEl = null;

const dummyFn = () => {
}

function renderImmersiveLightboxAt(fixedElement, videoProperties) {
  if (reactEl !== null) {
    reactEl.open({
      activeVideo: videoProperties.activeVideo,
      videosList: videoProperties.videosList,
      onAfterOpen: videoProperties.onAfterOpen || dummyFn,
      onPlaylistVideoPlay: videoProperties.onPlaylistVideoPlay || dummyFn,
      onClose: videoProperties.onClose || dummyFn
    })
  } else {
    const reactElTag = <ImmersiveLightbox {...videoProperties} />
    reactEl = ReactDOM.render(reactElTag, fixedElement);
    reactEl.show()
  }
}

// Extracted from https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

const trimSpaceAndEndline = (str) => {
  if (str) {
    return str.replace(/^\s+|\s+$/g, '')
  }
  return ''
}

// Extracted and adapted from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
const closest = (currentEl, s) => {
  let el = currentEl
  do {
    if (el.matches(s)) return el;
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);
  return null;
};

// const getFeedPostBody = (el) => {
//   const feedSelector = '.feed-post-body'
//   if (!Element.prototype.closest) {
//     return closest(el, feedSelector)
//   }
//   else {
//     return el.closest(feedSelector)
//   }

// }

const getFatherBody = (el, fatherSelector) => {
  // console.log('node3:', el)
  if (!Element.prototype.closest) {
    return closest(el, fatherSelector)
  }
  else {
    return el.closest(fatherSelector)
  }
}

const getVideoInfoFromHighlightedPost = (node) => {
  const postBodyEl = getFatherBody(node, '.bstn-hl.with-video')
  if (postBodyEl === null) return null
  const hlVideoEl = postBodyEl.querySelector('.bstn-hl-video')
  var title = hlVideoEl.dataset.title || hlVideoEl.getAttribute('title') || hlVideoEl.dataset.caption || getText(postBodyEl, '.bstn-hl-title')
  const description = node.dataset.description || getText(postBodyEl, '.bstn-hl-summary')
  const dataTitle = node.dataset.dataTitle
  const shortUrl = node.dataset.shortUrl
  const duration = getText(postBodyEl, '.bstn-hl-duration')
  let thumbSmall = hlVideoEl.dataset.img
  const matchedURL = postBodyEl.getAttribute('style').match(new RegExp('"https://.*"', 'g'))
  thumbSmall = thumbSmall || (matchedURL && matchedURL[0].replace('"', ''))

  const video = {
    id: hlVideoEl.dataset.videoId,
    title: title,
    description: description,
    duration: duration,
    dataTitle,
    shortUrl,
    publishedAt: getText(postBodyEl, '.feed-post-metadata .feed-post-datetime'),
    thumbSmall: thumbSmall || ''
  }

  return video
}

const getText = (el, s) => {
  if (el !== null) {
    const newEl = el.querySelector(s)
    if (newEl !== null) {
      return trimSpaceAndEndline(newEl.textContent)
    }
  }
  return ''
}

const getVideoInfoFromGrouper = (node) => {
  const grouperBodyEl = getFatherBody(node, '.video-fd')
  if (!grouperBodyEl) {
    return null
  }

  const title = node.dataset.title || node.getAttribute('title') || node.dataset.caption || grouperBodyEl.querySelector('.bstn-fd-item-cover.bstn-fd-video-cover').dataset.title
  const thumbSmallEl = grouperBodyEl && grouperBodyEl.querySelector('.video-fd .bstn-fd-cover-picture img')
  const videoId = grouperBodyEl && grouperBodyEl.querySelector('.bstn-fd-item-cover.bstn-fd-video-cover').dataset.videoId;
  const programTitle = grouperBodyEl && grouperBodyEl.querySelector('.bstn-fd-item-cover.bstn-fd-video-cover').dataset.programTitle
  const shortUrl = grouperBodyEl && grouperBodyEl.querySelector('.bstn-fd-item-cover.bstn-fd-video-cover').dataset.shortUrl

  const video = {
    id: videoId,
    title: title,
    description: '',
    duration: '',
    publishedAt: '',
    programTitle,
    shortUrl,
    thumbSmall: (thumbSmallEl && thumbSmallEl.src) || ''
  }
  return video;
}

const getVideoInfoFromFeed = (node) => {

  const postBodyEl = getFatherBody(node, '.feed-post-body')
  if (!postBodyEl) {
    return null
  }

  var title = node.dataset.title || node.getAttribute('title') || node.dataset.caption || getText(postBodyEl, '.feed-post-link')
  const description = node.dataset.description || getText(postBodyEl, '.feed-post-body-resumo')
  const duration = getText(postBodyEl, '.feed-post-video-duration')
  const programTitle = node.dataset.programTitle
  const shortUrl = node.dataset.shortUrl
  let thumbSmallEl = postBodyEl && postBodyEl.querySelector('.feed-media-wrapper .bstn-fd-cover-picture img')


  const video = {
    id: node.dataset.videoId,
    title: title,
    description: description,
    duration: duration,
    programTitle,
    shortUrl,
    publishedAt: getText(postBodyEl, '.feed-post-metadata .feed-post-datetime'),
    thumbSmall: (thumbSmallEl && thumbSmallEl.src) || ''
  }
  return video
}

const getVideoInfo = (node) => {
  let video = getVideoInfoFromHighlightedPost(node)
  if (video === null) {
    video = getVideoInfoFromGrouper(node)
  }
  if (video === null) {
    video = getVideoInfoFromFeed(node)
  }
  return video
}

const getLightboxEventHandler = () => {
  const fixedElement = document.createElement('div');
  fixedElement.setAttribute('id', 'lightboxRoot');
  document.body.appendChild(fixedElement);

  return (node, options) => {
    if (node !== null || node !== undefined) {
      // console.log('node1:', node)
      const video = getVideoInfo(node)
      options = { activeVideo: video, videosList: [video], ...options }
      node.addEventListener('click', (event) => {
        event.preventDefault();
        renderImmersiveLightboxAt(fixedElement, options);
      });
    }
  }
}

export const lightbox = getLightboxEventHandler();